// extracted by mini-css-extract-plugin
module.exports = {"swiperCard2":"swiperCard_swiperCard2__gN4hM"};